/**
 * Status chips for taxonomy list items.
 * Prefer effective/inherited lines when ancestors are provided.
 */
import { getCatalogTaxonomyEffectiveStatusLines } from './catalogTaxonomyEffectiveState'

export function getCatalogTaxonomyStatusLines(node, ancestors = [], options = {}) {
  if (!node) return []
  return getCatalogTaxonomyEffectiveStatusLines(node, ancestors, options)
}
